<template>
  <div class="main">
    <input type="file" id="___file_upload" ref="referenceUpload" accept="image/*" @change="upload" />
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">申请</div>
      <div class="nav-right">
        <img class="none" />
      </div>
    </div>
    <div class="info2">
        <div class="ub ub-pc ub-ac2">
             <span class="sp1">上传图片</span>
             <span class="sp2">{{ayy_pic.length}}/4</span>
        </div>
       </div>
       <div class="info3">
        <div class="pic ub ub-pc">
          
            <div v-for="(i,index) in ayy_pic" :key="index" class="ub ub-ac ub-pc ub-ver screenshots-div">
                <div class="remove" @click="remove_pic(index)">×</div>
                <img :src="i" class="face-img" @click="show_full(i)"/>
            </div>
          <div v-show="ayy_pic.length<=3" class="add ub ub-pc ub-ac">
              <img src="../../assets/img/添加图片.png" class="add-img" @click="upload_img()"/>
          </div>
        </div>
    </div>
    <div class="ub ub-ac" style="padding: 0 .8em;">
      <div class="ub ub-ac ub-pc submit-btn" @click="save()" >下一步</div>
    </div>
    <full_pic ref="myFullPic"></full_pic>
  </div>
</template>

<script>
import Exif from "exif-js";
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";
import full_pic from "../../components/Full_Pic.vue";
export default {
   components: {
    full_pic: full_pic,
  },
  data() {
    return {
      "ayy_pic": [],
    };
  },
  mounted() {
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post", "post2"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },

    init_page() {
      var uid = this.$store.state.uid;
      var self = this;
      this.$loading("加载...");
      setTimeout(() => {
        self.$loading.close();
      }, 5000);
      self.get({
        url: "/App/Get_Play_Data_One/?uid=" + uid,
        success: function (data) {
          self.$loading.close();
          if(data.pics){
            self.ayy_pic = data.pics.split(',');
          }
          
        },
      });
    },

    save(){
      if(this.ayy_pic.length<=0){
         this.$toast.center("请上传图片");
        return false;
      }

    var uid = this.$store.state.uid;

     var self = this;
     var data_send={
       "pics":this.ayy_pic.join(",")
     };
     var strsend = JSON.stringify(data_send);

      this.post({
          url: "/App/Update_User_Play",
          data: { "uid": uid, "data": strsend },
          success: function (serve_data) {
           console.log(JSON.stringify(serve_data));
            if(serve_data.state=="1"){
              self.$router.push({ "name": "play_apply4" });
            }
          },
        });
     
    },

    upload_img() {
      //触发input的change事件
      var ie =
        navigator.appName == "Microsoft Internet Explorer" ? true : false;
      if (ie) {
        document.getElementById("___file_upload").click();
      } else {
        var a = document.createEvent("MouseEvents"); //FF的处理
        a.initEvent("click", true, true);
        document.getElementById("___file_upload").dispatchEvent(a);
      }
    },
    upload(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.picValue = files[0];

      var arrExt = [".png", ".jpg", ".jpeg", ".gif", ".bmp"];
      var file_name = this.picValue.name;
      var fileExt = file_name.substr(file_name.lastIndexOf(".")).toLowerCase();

      if (arrExt.indexOf(fileExt) <= -1) {
        //上传文件格式不正确
        this.$toast.center("不支持您所选的图片格式~");
        return false;
      }

      //toast 启动动画
      this.$loading("上传中...");

      this.imgPreview(this.picValue);
    },

    postImg() {
      var self = this;

      //这里写接口
      var base64 = this.headerImage;
      let param = new FormData(); // 创建form对象
      param.append("imgFile", base64); //对应后台接收图片名

      //判断base64 是否成功, 长度>10
      if (base64.length < 10) {
        //消掉动画
        self.$loading.close();
        self.$toast.center("图片处理失败,请重新选择");
        return false;
      }

      this.post2({
        url: "/Common/UpLoadImage_Base64_2",
        data: param,
        success: function (serve_data) {
          //消掉动画
          self.$loading.close();
          //self.$toast.center('上传成功');
          var pic_url = self.$store.state.url + serve_data;
          self.ayy_pic.push(pic_url);
        },

        error: function (err) {
          //消掉动画
          self.$loading.close();
          self.$toast.center("上传失败,请重新再来");
        },
      });
    },

    imgPreview(file) {
      let self = this;
      let Orientation;
      //去获取拍照时的信息，解决拍出来的照片旋转问题
      Exif.getData(file, function () {
        Orientation = Exif.getTag(this, "Orientation");
      });
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;
      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function () {
          let result = this.result;
          let img = new Image();
          img.src = result;
          //判断图片是否大于4M,是就直接上传，反之压缩图片
          var pic_size = ((this.result.length * 1.0) / (1024 * 1024)).toFixed(
            2
          );

          if (this.result.length <= 4 * 1024 * 1024) {
            self.headerImage = this.result;

            self.postImg();
          } else {
            img.onload = function () {
              let data = tool.compress(img, Orientation);
              self.headerImage = data;
              self.postImg();
            };
          }
        };
      }
    },
    show_full(url) {
      this.$refs.myFullPic.show(url);
    },
    remove_pic(index) {
      this.ayy_pic.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.main{
   position: absolute;
   background-color: #fff;
   width: 100%;
   bottom: 0;
   top:0;
 }
#___file_upload {
  position: absolute;
  left: -999px;
}

.info2{
  padding: .8em;
}
.info2 .sp1{
  font-size: 1.05em;
  font-weight: bold;
}
.info3{
  padding: 0 .3em .8em .3em;
  border-bottom: .5em solid #f5f5f5;
}
.sp2{
  font-size: 1em;
  color:#999;
}
.pic{
    margin: 0 0 .5em 0;
}
.add{
    width: 21%;
    height: 4.75em;
    background-color: #f7f8fa;
    border-radius: .5em;
    border: 1px dashed #d8d8d8;
    margin: .8em 0 0 2.6%;
}
.add-img{
    width: 2em;
    height: 2em;
}
.screenshots-div {
  width: 21%;
 height: 4.75em;
  border-radius: .5em;
  background-color: #f5f5f5;
  border: 1px dashed #d8d8d8;
  position: relative;
  margin:0.8em 0 0 2.6%;
}
.face-img {
  height:100%;
  max-width: 100%;
  border-radius: .5em;
}

.remove {
  position: absolute;
  top:0;
  z-index: 3;
  border-radius: 50%;
  width: 0.9em;
  height: 0.9em;
  line-height: 1em;
  text-align: center;
  font-size: 1.3em;
  background-color: white;
  margin-bottom: 3.34em;
  right: 0;
}
 .submit-btn {
  width: 100%;
  height: 2.3em;
  line-height: 2.3em;
  border-radius: 1.15em;
  background-color: #fc568c;
  margin-top: .5em;
  color: #fff0f4;
}

</style>